jQuery(document).ready(function () {
    $(document).on('shown.bs.dropdown', '.dnHeaderSearch-dropdown', function (e) {
        $('.dnHeaderSearch-input').focus();
    });

    $(document).on('click', '.dnHeaderSearch-icon', function (e) {
        $('.dnHeaderSearch-input').focus();
    });
});
